import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const track = (event, data = {}) => {
  axios
    .post(`${API}/track`, {
      event,
      path: window.location.pathname,
      ref: document.referrer || "",
      ...data,
    })
    .catch(() => {});
};
